import { useState } from "react";
import { useTranslation } from "react-i18next";
import ApprovalSchoolRegistrationComponent from "src/components/user/approval-school-registration-component";
import QuestionsForSchoolLeaderComponent from "src/components/user/questions-school-leader-component";

function QuestionsSchoolLeaderContainer() {
  const { i18n, t } = useTranslation();
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);
  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className={`flex items-center justify-center z-40 relative ${
        !formSubmitted ? "mt-[480px] mobile:mt-64" : "mt-80 mobile:mt-64"
      }  pb-20`}
    >
      {!formSubmitted ? (
        <div className="flex-col items-start gap-[60px] inline-flex">
          <p
            className={`font-arMedium text-black344 text-3xl ${
              i18n.language === "ar" ? "text-right w-[607px]" : "text-left"
            } leading-9 mobile:text-xl mobile:w-[336px] mobile:leading-6`}
          >
            {t(
              "schoolLeader.validation.container.schoolSuccessfullyRegistered"
            )}
            <br />
            {t("schoolLeader.validation.container.pleaseAnswerQuestion")}
          </p>
          <QuestionsForSchoolLeaderComponent
            formSubmitted={formSubmitted}
            setFormSubmitted={setFormSubmitted}
          />
        </div>
      ) : (
        <ApprovalSchoolRegistrationComponent />
      )}
    </div>
  );
}

export default QuestionsSchoolLeaderContainer;
